<nav class="navbar-default navbar-static-side" role="navigation" [hidden]="!user">
    <div>
        <ul class="nav metismenu" id="side-menu">
            <li [ngClass]="{ 'mm-active': activeRoute('jobs') }">
                <a href="#"><span class="nav-label">Jobs</span></a>
                <ul class="nav nav-second-level mm-collapse" routerLinkActive="in">
                    <li routerLinkActive="active">
                        <a [routerLink]="['/jobs/active']">Active Jobs</a>
                    </li>
                    <li routerLinkActive="active">
                        <a [routerLink]="['/jobs/search']" [hidden]="!auth.hasRole('JobAdmin') && !auth.hasRole('Admin')">Overview</a>
                    </li>
                </ul>
            </li>
            <li [ngClass]="{ 'mm-active': activeRoute('time') }">
                <a href="#"><span class="nav-label">Time</span></a>
                <ul class="nav nav-second-level mm-collapse" routerLinkActive="in">
                    <li routerLinkActive="active"><a [routerLink]="['/time/overview']">Overview</a></li>
                    <li routerLinkActive="active"><a [routerLink]="['/time/payroll']" [hidden]="!auth.hasRole('TimeAdmin') && !auth.hasRole('Admin')">Payroll</a></li>
                </ul>
            </li>

            <li [ngClass]="{ 'mm-active': activeRoute('invoices') }" [hidden]="!auth.hasRole('BillingAdmin') && !auth.hasRole('Admin')">
                <a href="#"><span class="nav-label">Billing System</span></a>
                <ul class="nav nav-second-level mm-collapse" routerLinkActive="in">
                    <li routerLinkActive="active">
                        <a [routerLink]="['/invoices/search']" [hidden]="!auth.hasRole('Admin')">Invoices</a>
                    </li>
                    <li routerLinkActive="active">
                        <a [routerLink]="['/invoices/purchase-order']">Purchase Orders</a>
                    </li>
                    <!-- <li routerLinkActive="active">
                        <a [routerLink]="['/invoice/payments']">Payments<span class="badge badge-warning ml-2">ALPHA</span></a>
                    </li> -->
                </ul>
            </li>

            <li [ngClass]="{ 'mm-active': activeRoute('admin') }" [hidden]="!auth.hasRole('Admin')">
                <a href="#"><span class="nav-label">Admin</span></a>
                <ul class="nav nav-second-level mm-collapse" routerLinkActive="in">
                    <li routerLinkActive="active"><a [routerLink]="['/admin/employees']">Employees</a></li>
                    <li routerLinkActive="active"><a [routerLink]="['/admin/users']">Users</a></li>
                    <li routerLinkActive="active"><a [routerLink]="['/admin/lookup-tables']">Lookup Tables</a></li>
                </ul>
            </li>
        </ul>
        <div style="padding: 30px 25px 0px; font-size: 8pt; color: aliceblue" title="{{ appInfo.appVersion }}">version: <strong>{{ appInfo.appVersion }}</strong></div>
        <div style="padding: 0px 25px; font-size: 8pt; color: aliceblue">user: {{ user?.userName }}</div>

        <div style="padding: 30px 25px 0px; font-size: 8pt; color: aliceblue">Week of {{ startDate | date: 'MM/dd/yyyy' }}</div>
        <div style="padding: 0px 25px; font-size: 8pt; color: aliceblue">Sun: {{ sunday }}</div>
        <div style="padding: 0px 25px; font-size: 8pt; color: aliceblue">Mon: {{ monday }}</div>
        <div style="padding: 0px 25px; font-size: 8pt; color: aliceblue">Tue: {{ tuesday }}</div>
        <div style="padding: 0px 25px; font-size: 8pt; color: aliceblue">Wed: {{ wednesday }}</div>
        <div style="padding: 0px 25px; font-size: 8pt; color: aliceblue">Thu: {{ thursday }}</div>
        <div style="padding: 0px 25px; font-size: 8pt; color: aliceblue">Fri: {{ friday }}</div>
        <div style="padding: 0px 25px; font-size: 8pt; color: aliceblue">Sat: {{ saturday }}</div>

        <div style="padding: 30px 25px 0px; font-size: 8pt; color: aliceblue">Week of {{ lastStartDate | date: 'MM/dd/yyyy' }}</div>
        <div style="padding: 0px 25px; font-size: 8pt; color: aliceblue">Sun: {{ lastSunday }}</div>
        <div style="padding: 0px 25px; font-size: 8pt; color: aliceblue">Mon: {{ lastMonday }}</div>
        <div style="padding: 0px 25px; font-size: 8pt; color: aliceblue">Tue: {{ lastTuesday }}</div>
        <div style="padding: 0px 25px; font-size: 8pt; color: aliceblue">Wed: {{ lastWednesday }}</div>
        <div style="padding: 0px 25px; font-size: 8pt; color: aliceblue">Thu: {{ lastThursday }}</div>
        <div style="padding: 0px 25px; font-size: 8pt; color: aliceblue">Fri: {{ lastFriday }}</div>
        <div style="padding: 0px 25px; font-size: 8pt; color: aliceblue">Sat: {{ lastSaturday }}</div>
    </div>
</nav>
